module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/boardgame-icon-88205335724556ec6cedc4353b95de42.png";